/* VESPER product page controller — variant picker, gallery, size-guide dialog.
 * Wired to the embedded variant map; updates the native product form's id input,
 * price, availability, and per-option sold-out states. */
(function () {
  function boot() {
    var root = document.querySelector('.vesper .pdp-page');
    if (!root || root.dataset.vpInit === '1') return;
    root.dataset.vpInit = '1';

    var form = document.getElementById('vp-form');
    var idInput = root.querySelector('[data-vp-id]');
    var priceEl = root.querySelector('[data-vp-price]');
    var addBtn = root.querySelector('[data-vp-add]');
    var addLabel = root.querySelector('[data-vp-add-label]');
    var stockEl = root.querySelector('[data-vp-stock]');
    var optBtns = Array.prototype.slice.call(root.querySelectorAll('[data-vp-opt]'));

    var variants = [];
    var json = root.querySelector('[data-vp-variants]') || document.querySelector('[data-vp-variants]');
    try { variants = JSON.parse(json.textContent || '[]'); } catch (e) { variants = []; }

    // selected[] indexed by option position-1
    var selected = [];
    optBtns.forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') {
        selected[parseInt(b.dataset.vpOpt, 10) - 1] = b.dataset.vpValue;
      }
    });

    function match(sel) {
      return variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    function update() {
      var cv = match(selected);
      // sold-out / availability per option value (cross-option aware)
      optBtns.forEach(function (b) {
        var pos = parseInt(b.dataset.vpOpt, 10) - 1;
        var test = selected.slice(); test[pos] = b.dataset.vpValue;
        var m = match(test);
        var unavailable = !m || m.available === false;
        if (b.classList.contains('opt-cell')) b.disabled = unavailable;
        b.setAttribute('aria-pressed', selected[pos] === b.dataset.vpValue ? 'true' : 'false');
      });
      // color chosen labels
      root.querySelectorAll('[data-vp-chosen]').forEach(function (el) {
        el.textContent = selected[parseInt(el.dataset.vpChosen, 10) - 1] || '';
      });
      if (cv) {
        if (idInput) idInput.value = cv.id;
        if (priceEl) priceEl.innerHTML = (cv.cap ? '<s>' + cv.cap + '</s> ' : '') + cv.price;
        if (addBtn) addBtn.disabled = cv.available === false;
        if (addLabel) addLabel.textContent = cv.available === false ? 'Sold out' : 'Add to bag — ' + cv.price;
        if (stockEl) {
          if (cv.qty != null && cv.qty > 0 && cv.qty <= 12) {
            stockEl.innerHTML = '<i></i><span><b>Only ' + cv.qty + ' left</b> in this run</span>';
          } else if (cv.available !== false) {
            stockEl.innerHTML = '<i></i><span>In stock · ships in 1–2 days</span>';
          }
        }
        if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
      }
    }

    optBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        selected[parseInt(b.dataset.vpOpt, 10) - 1] = b.dataset.vpValue;
        update();
      });
    });

    // Gallery thumbs
    var main = root.querySelector('[data-vp-main]');
    root.querySelectorAll('[data-vp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) main.src = t.dataset.vpThumb;
        root.querySelectorAll('[data-vp-thumb]').forEach(function (x) { x.dataset.on = '0'; });
        t.dataset.on = '1';
      });
    });

    // Size & fit dialog
    var dlg = document.querySelector('[data-vp-sizeguide-dialog]');
    root.querySelectorAll('[data-vp-sizeguide]').forEach(function (g) {
      g.addEventListener('click', function () { if (dlg && dlg.showModal) dlg.showModal(); });
    });
    if (dlg) {
      var close = dlg.querySelector('[data-vp-sizeguide-close]');
      if (close) close.addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    // Only run variant matching when there are options to pick. For single-variant
    // products the Liquid-rendered id/price/availability are already correct.
    if (optBtns.length) update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
